import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchIntegration,
  fetchAllIntegration,
  fetchIntegrationBySource,
} from "./meetingIntegrationAPI";

export const getIntegration = createAsyncThunk(
  "meetingIntegration/getIntegration",
  async (uuid, thunkAPI) => {
    try {
      const data = await fetchIntegration(uuid);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const getAllIntegration = createAsyncThunk(
  "meetingIntegration/getAllIntegration",
  async (search = "", thunkAPI) => {
    try {
      const data = await fetchAllIntegration(search);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getIntegrationBySource = createAsyncThunk(
  "meetingIntegration/getBySource",
  async (sourceName = "", thunkAPI) => {
    try {
      const data = await fetchIntegrationBySource(sourceName);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  },
);

const integrationSlice = createSlice({
  name: "meetingIntegration",
  initialState: {
    integrations: [],
    sourceIntegrations: [],
    selectedIntegration: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearSelectedIntegration(state) {
      state.selectedIntegration = null;
      state.error = null;
    },
    clearError(state) {
      state.error = null;
    },
    clearIntegrations: (state) => {
      state.integrations = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getIntegration.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getIntegration.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedIntegration = action.payload;
      })
      .addCase(getIntegration.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getAllIntegration.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllIntegration.fulfilled, (state, action) => {
        state.loading = false;
        state.integrations = action.payload;
      })
      .addCase(getAllIntegration.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getIntegrationBySource.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getIntegrationBySource.fulfilled, (state, action) => {
        state.loading = false;
        state.sourceIntegrations = action.payload.data;
      })
      .addCase(getIntegrationBySource.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearSelectedIntegration, clearError, clearIntegrations } =
  integrationSlice.actions;

export default integrationSlice.reducer;
